import React, { FC, useState, useEffect } from 'react';
import { useFormikContext, FormikValues } from 'formik';
import { listGoggleModels } from '../../../../../api/ordersApi';

type Step2Props = {
  selectedGoggleModelQuantities: { [key: number]: number };
  setSelectedGoggleModelQuantities: React.Dispatch<React.SetStateAction<{ [key: number]: number }>>;
};

const Step2_2: FC<Step2Props> = ({ selectedGoggleModelQuantities, setSelectedGoggleModelQuantities }) => {
  const [goggleModelList, setGoggleModelList] = useState<any[]>([]);
  const [selectedGoggleModelIds, setSelectedGoggleModelIds] = useState<number[]>([]);

  // Usa Formik per accedere al valore del campo "Quantita_visori"
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  useEffect(() => {
    const fetchModelliVisori = async () => {
      try {
        const response = await listGoggleModels();
        setGoggleModelList(response);

        // Creiamo qui la mappatura dei nomi dei modelli ai loro ID
        const modelNameToId = response.reduce((acc: {[key: string]: number}, modello: {Modello: string, ID_Visore: number}) => {
          acc[modello.Modello] = modello.ID_Visore;
          return acc;
        }, {} as {[key: string]: number});

        setSelectedGoggleModelQuantities({}); // Resetta a un oggetto vuoto
  
        const modelloConteggioParts = values.ModelliConteggio.split(","); // ["1x Quest 2", "2x Quest 3"]
        let totalQuantity = 0;
  
        modelloConteggioParts.forEach((part: string) => {
          const [quantita, ...modelloParts] = part.trim().split(" ");
          const quantitaVisori = parseInt(quantita.replace('x', ''), 10);
          totalQuantity += quantitaVisori;
          const modello = modelloParts.join(' ');
  
          const modelloId = modelNameToId[modello];
  
          if (modelloId !== undefined) {
            setSelectedGoggleModelQuantities(prev => {
              // Definisci il tipo di prev come { [key: number]: number }
              const newQuantities: {[key: number]: number} = {...prev};
              newQuantities[modelloId] = (prev[modelloId] || 0) + quantitaVisori;
              return newQuantities;
            });
            setSelectedGoggleModelIds(prev => {
              const newIds = Array(quantitaVisori).fill(modelloId);
              return [...prev, ...newIds];
            });
          }
        });
      } catch (error) {
        console.error('Errore nel recupero dei modelli di visore:', error);
      }
    };
    fetchModelliVisori();
  }, []);

  /* Funzione incremento */
  const incrementModel = (modelId: number, event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSelectedGoggleModelQuantities(prevQuantities => {
      // Calcola la nuova quantità incrementando il valore corrente, o inizializzandolo a 1 se non esiste
      const nuovaQuantita = (prevQuantities[modelId] || 0) + 1;

      const newQuantities = { ...prevQuantities, [modelId]: nuovaQuantita };
    
      // Aggiorna il campo Formik con le nuove quantità
      setFieldValue('quantitaVisoriPerModello', newQuantities);
    
      return newQuantities;
    });
  };

  /* Funzione decremento */
  const decrementModel = (modelId: number, event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setSelectedGoggleModelQuantities(prev => {
      if (prev[modelId] && prev[modelId] > 0) {
        const nuovaQuantita = prev[modelId] - 1;
        const updatedQuantities = {
          ...prev,
          [modelId]: nuovaQuantita
        };

        // Aggiorna il campo Formik con le nuove quantità
        setFieldValue('quantitaVisoriPerModello', updatedQuantities);

        return updatedQuantities;
      }
      return prev;
    });
  };

  return (
    <div className='w-100'>
      {/* Inizio modello visore */}
      <div className='mb-10 fv-row'>
        <label className='d-flex align-items-center form-label mb-5 required'>
          Modello visore
        </label>

        <div>
          {goggleModelList.map((modello) => (
            <div key={modello.ID_Visore} className="d-flex align-items-center mb-3">
              <span 
                style={{
                  width: '250px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {modello.Modello}
              </span>
              
              <div className="d-flex align-items-center" style={{ marginLeft: 'auto' }}>
                <button 
                  type="button"
                  className="btn btn-icon btn-active-color-gray-700 ms-5"
                  onClick={(e) => decrementModel(modello.ID_Visore, e)}
                >
                  -
                </button>
              
                <span className="mx-3" style={{ width: '20px', textAlign: 'center' }}>
                  {selectedGoggleModelQuantities[modello.ID_Visore] || 0}
                </span>
              
                <button 
                  type="button"
                  className="btn btn-icon btn-active-color-gray-700"
                  onClick={(e) => incrementModel(modello.ID_Visore, e)}
                >
                  +
                </button>
              </div>
            </div>
          ))}
        </div>

        {/*<div className='form-text'>
            Visori totali selezionati: {Object.values(selectedGoggleModelQuantities).reduce((a, b) => a + b, 0)}
          </div>*/}
      </div>
      {/* Fine modello visore */}
    </div>
  );
};

export { Step2_2 };